// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__AA9op","code":"NotFound_code__n3FlE","message":"NotFound_message__YdKU+","link":"NotFound_link__VhtBb"};